import { ClientSetup } from '../../classes/client-setup.interface';

export const default_ClientSetup: ClientSetup = {
  splashRoute: '/taiao',
  streamBranding: true,
};
